import React, { Component } from 'react';
import * as d3 from 'd3';

//images
import ImgCoco from '../images/villagers/Coco.png';
import ImgLucky from '../images/villagers/Lucky.png';


import StarSvgUrl from '../images/star.svg';
import Dialogue from '../components/Dialogue';

import ChartSpecs from '../data/chart_specs';

const colorWheelObj = ChartSpecs.chartspecs.colorWheelObjBoolean
var colorWheelArray = Object.keys(colorWheelObj);
var colorRange = Object.values(colorWheelObj);
var margin = ChartSpecs.chartspecs.margin;


class VillagerAppearanceUnique extends Component {

  constructor(props){
      super(props);
      this.svgRef = React.createRef();

      this.allVillagers = this.props.villagers;
      this.tierNodes = {};
   }

   componentDidMount() {
     this.svg = d3.select(this.svgRef.current);
     this.drawStackBarChart();
   }

    drawStackBarChart(){
      var svg = this.svg,
          chartWidth = this.svgRef.current.clientWidth,
          chartHeight = 430,
          stackKeys = colorWheelArray,
          radius = 40,
          tooltip = d3.select('#tooltip-unique'),
          skinColors =  this.props.villagerSkinColors,
          textColors =  this.props.villagerTextColors;

      let allVillagers = this.allVillagers;
      /* COLOR NODES SORT */
      //let tierNodes = d3.group(allVillagers, d => d.tier);
      let tierNodes = d3.groups(allVillagers, d => d.tier, d => d.Combined_special_appearance);
      let tierNodes2 = d3.rollup(allVillagers, v => v.length, d => d.tier, d => d.Combined_special_appearance);
      let tierArray = [...tierNodes2.keys()];

      let tableData = Array.from(tierNodes2.entries())
      .map(g => {
        const obj = {};
        obj["tier"] = g[0];
        for (let col of stackKeys) {
          const vals = g[1].get(col);
          //console.log("vals: "+vals);
          obj[col] = !vals ? 0 : vals;
        }
        return obj;
      })
     .sort((a, b) => a["tier"] - b["tier"]);




      chartHeight = tierNodes.length * radius + margin.top + margin.bottom

      const yScale = d3.scaleBand()
            //.domain(tierNodes.map(d => d[0])) //tiers
            .domain(tierArray)
            .range([margin.top, chartHeight - margin.bottom])
            .padding(0.25)

      const xScale= d3.scaleLinear()
                    .range([margin.left, chartWidth - margin.right])


      const colorScale = d3.scaleOrdinal()
                  .domain(colorWheelArray)
                  .range(colorRange)

      const xAxis = g => g
                  .attr("transform", `translate(0,${margin.top+10})`)
                  .call(d3.axisTop(xScale).ticks(chartWidth / 100, "%"))
                  .call(g => g.selectAll(".domain").remove());

      const yAxis = g => g
                .attr("transform", `translate(${margin.left},0)`)
                .call(d3.axisLeft(yScale).tickFormat(function(d,i){ return `T.${d}` }).tickSizeOuter(0))
                .call(g => g.selectAll(".domain").remove())

      const formatPercent = d3.format(".1%");
      const formatValue = x => isNaN(x) ? "N/A" : x.toLocaleString("en")
      /* set up mutiple colli  */
      let basePerRow = 10,
          baseRowWidth = (chartWidth + 0) / (basePerRow + 1);

      const series = d3.stack()
                    .keys(stackKeys)
                    .offset(d3.stackOffsetExpand)
                  (tableData)
                    .map(d => (d.forEach(v => v.key = d.key), d))

      svg.attr("id", 'uniqueAppearanceChart');
      svg.attr("height", chartHeight);

      svg.append("g")
      .attr("class", 'xaxis')
      .call(xAxis);

      svg.append("g")
      .attr("class", 'yaxis tier-axis no-tick')
      .call(yAxis);

      svg.append("g")
         .selectAll("g")
         .data(series)
         .join("g")
         .attr("fill", d => colorScale(d.key))
         .selectAll("rect")
         .data(d => d)
         .join("rect")
         .attr("x", d => xScale(d[0]))
         .attr("y", (d, i) => yScale(d.data.tier))
         .attr("width", d => xScale(d[1]) - xScale(d[0]))
         .attr("height", yScale.bandwidth())
         .on("mouseenter", function(e,d) {
            const x = xScale(d[0]) + (xScale(d[1]) - xScale(d[0])) / 2;
            const y = yScale(d.data.tier);

            let thisBar = d3.select(this);


            d3.select('#tooltip-unique')
                        .transition()
                        .duration(200)
                        .style("display", "block");

            d3.select('#tooltip-unique')
              .html(
                `<p> <b>${formatValue(d.data[d.key])}</b> villagers</p>`
              ).style(
                    "transform",
                    `translate(` + `calc( -50% + ${x}px),` + `calc(-100% + ${y}px)` + `)`
                  );

             d3.select(this).transition()
                    .duration(350)
                    .style("stroke", d => colorScale(d.key))

          })
          .on('mouseleave', function() {
            d3.select('#tooltip-unique')
              .transition()
              .duration(200)
              .style("display", "none")

            d3.select(this)
              .transition()
              .style("stroke", 'none')
          })
    }



  render() {
    let topVillagers = this.allVillagers.filter(v => v.Average_Popularity_Ranking <= 40);
    let topUniqueVillagersCount = topVillagers.filter(v => v.Combined_special_appearance === "special").length;
    let topUniqueVillagersPercentage = Number(topUniqueVillagersCount/40).toLocaleString(undefined,{style: 'percent', minimumFractionDigits:1});


    return (
      <div ref={this.props.innerRef}  id={`villager-${this.props.step}`} className="step category-appearance">
        <h2 className="title">Special designs</h2>
        <p className="paragraph">Villagers can be memorable when they have a unique character design. For example:</p>
        <div className="unique-villagers">
          <div className="unique-villager">
            <img alt='Coco' src={ImgCoco}/>
            <span className="description">
              <span className="name">Coco <span className="ranking">9</span></span>
              <span className="sub">Rabbit with a coconut for a head</span>
            </span>
          </div>
          <div className="unique-villager">
            <img alt='Lucky' src={ImgLucky}/>
            <span className="description">
              <span className="name">Lucky <span className="ranking">11</span></span>
              <span className="sub">Dog covered with bandages like a mummy</span>
            </span>
          </div>
        </div>
        <p className="paragraph"> <span className="medium">Do these special designs make a villager more popular? </span></p>
        <p className="paragraph">We labeled each villager based on whether they had a <span className="unique-square unique">unique character design</span> and looked at the distribution of unique character designs across the popularity rankings. Each bar represents one popularity tier.</p>

        <div className="svg-wrapper">
          <div id="tooltip-unique" className="bar-tooltip"></div>
          <svg ref={this.svgRef} width="100%"></svg>
        </div>

        <p className="paragraph haspointer">We found that <span id="acnh-icon-star" style={{ backgroundImage: `url(${StarSvgUrl})`}}></span> <b>{topUniqueVillagersPercentage}</b> of the Tier 1 villagers, shown to the left, have special character designs. The chart above shows that the percentage of villagers with special designs drops significantly after Tier 2. </p>

        <p className="paragraph">The slight increase in special character designs in Tier 10 is because the newer <a className="inline-tooltip" href="#" aria-label="These villagers are a special collaboration with Sanrio and are inspired by Sanrio characters. These villagers can only be met by buying Nintendo’s Amiibo cards, so they are not tradeable on Nookazon and do not have a marketplace value.">Sanrio characters</a> are considered unique character designs as well.</p>

        <Dialogue title="Summary" type="regular">
          <p className="paragraph">Villagers with special character designs tend to be more popular.</p>
        </Dialogue>
      </div>
    )
  }
}

export default VillagerAppearanceUnique;
